import React, {Component} from 'react';
import VendorComponent from './VendorComponent';
import AOS from 'aos';

class VendorsComponent extends Component {
    componentDidMount() {
        window.scrollTo(0, 0)
        AOS.init();
    }

    clickHandler = (event,index) => {
        event.preventDefault()
        if(this.props.location.state.categories[index].alldayExists && this.props.location.state.categories[index].onedayExists)
            this.props.history.push(process.env.PUBLIC_URL+'/select-category/'+this.props.location.state.categories[index]._id)
        else if(this.props.location.state.categories[index].alldayExists)
            this.props.history.push(process.env.PUBLIC_URL+'/category/allday/view-all/'+this.props.location.state.categories[index]._id)
        else if(this.props.location.state.categories[index].onedayExists)
            this.props.history.push(process.env.PUBLIC_URL+'/category/oneday/view-all/'+this.props.location.state.categories[index]._id)
    }

    render() {
        return (
            <div id="silverbackdeals" className="inner-categories choose-deals-outer p-l-0 p-r-0">
                <div className="container">
                    <div className="listing-categories">
                        <div className="row">
                            <div className="col-12 px--xs-0">
                                <h4>{this.props.location.state.title}</h4>
                            </div>
                            {this.props.location.state.categories.map((category,index) => (
                                <VendorComponent key={category._id} name={category.name} image={category.image} clickHandler={(event,index) => this.clickHandler(event,index)} index={index}/>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default VendorsComponent;